import { useAtom } from "jotai";
import { siteAtom } from "@/store";
import { toast } from "sonner";
import { useMapLibre } from "@/hooks";
import { MissionType, SiteType } from "@/types";
import { LngLat } from "maplibre-gl";
import { useTranslations } from "next-intl";

export const useSite = () => {
  const t = useTranslations("site.SiteToast");
  const { map } = useMapLibre();
  const [site, storeSite] = useAtom(siteAtom);
  const { flyTo } = useMapLibre();

  const setSite = (newSite: SiteType) => {
    if (site) {
      unpinSite(site);
    }

    locateSite(newSite);
    pinSite(newSite);
    storeSite(newSite);
  };

  const resetSite = () => {
    if (site) {
      unpinSite(site);
    }
    storeSite(null);
  };

  const locateSite = (site: SiteType) => {
    const position = getPosition(site);

    if (position) {
      flyTo(position);
    } else {
      toast(t("title"), {
        description: t("description"),
      });
    }
  };

  const pinSite = (site: SiteType | string | number) => {
    map!.setFeatureState(
      {
        source: "source",
        id: typeof site === "object" ? site.site_id : site,
      },
      {
        active: true,
      },
    );
  };

  const unpinSite = (site: SiteType | string | number) => {
    map!.removeFeatureState({
      source: "source",
      id: typeof site === "object" ? site.site_id : site,
    });
  };

  const getPosition = (site: SiteType) => {
    if (site.latitude && site.longitude) {
      return new LngLat(site.longitude, site.latitude);
    }

    return undefined;
  };

  const getMissions = (site: SiteType, missions: MissionType[]) => {
    return missions.filter((mission) => {
      if (mission.site_ids)
        return mission.site_ids.split(",").includes(String(site.site_id));
    });
  };

  return {
    site,
    setSite,
    resetSite,
    locateSite,
    pinSite,
    unpinSite,
    getMissions,
  };
};
